<template>
    <div>
      <div class="popup-info popup-icon-info">
          <svg style="height: 48px;">
            <use xlink:href="@/assets/img/big-icons-sprite.svg#recycle-car"></use>
          </svg>

          <div class="text mt24">
              <div class="text-size-l text-bold info-title text-color-red2" >Удалить правило навсегда?</div>

              <p class="info-text mt16 text-color-red2">
                  Это действие реально нельзя отменить.
              </p>
          </div>

          <div class="mt24">
              <submit-btn @click.native="remove" :type="btnType"><span class="i i-ok7 mr8"></span>Подтвердить</submit-btn>
          </div>
      </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue'

    export default {
        name: "RemoveRuleForever",
        components: {
            SubmitBtn
        },
        data() {
            return {
                btnType: 'normal',
            }
        },
        props: {
        },
        methods: {
            remove(){
                this.btnType = 'load';
                this.$store.dispatch('rules/removeRule', {
                id: this.item.id,
                forever: true,
                section: this.activeTopSection,
                }).then((isLast)=>{
                    this.btnType = 'ok';
                    this.$store.commit('popups/close', {name: this.popups.removeRuleForever.name});
                    this.$store.commit('popups/close', {name: this.popups.addRule.name});
                    this.$store.commit('popups/close', {name: this.popups.ruleDetail.name});
                    // Если больше нет элементов в корзине
                    if(isLast){
                        this.$router.push('/');
                    } else {
                      if (this.$router.history.current.path !== '/removed/') {
                        this.$router.push('/removed/');
                      }
                    }
                });
            },
            close: function () {
                this.$store.commit('popups/close', {name: this.popups.removeRuleForever.name});
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                item: state => state.rules.editItem,
                topSections: state => state.rules.topSections,
            }),
            isRemovedPage (){
                return this.$route.name == 'rules-removed';
            },
            activeTopSection(){
                if(this.isSearch) return false;
                return this.$route.params.id ? this.$route.params.id : this.topSections[0].id;
            },
        }
    }
</script>

<style scoped>

</style>
